import {UHttp} from "../../utils/UHttp"

const apiUrlServer = process.env.REACT_APP_URL_SERVER;

// Types pour les avis
export interface Review {
  id: string;
  professionalId: string;
  clientId: string;
  bookingId: string;
  rating: number;
  comment: string;
  response?: string;
  isPublic: boolean;
  createdAt: string;
  updatedAt: string;
  client?: {
    firstName: string;
    lastName: string;
  };
  booking?: {
    date: string;
    serviceId: string;
  };
}

// Types pour les statistiques d'avis
export interface ReviewStats {
  averageRating: number;
  count: number;
  ratingDistribution: {
    [key: number]: number;
  };
}

// Types pour les réponses API
export interface ReviewResponse<T = any> {
  success: boolean;
  message: string;
  review?: T;
}

export interface ReviewsResponse {
  success: boolean;
  message: string;
  reviews: Review[];
  count: number;
}

export interface ReviewStatsResponse {
  success: boolean;
  message: string;
  count: number;
  ratingDistribution?: { [key: number]: number };
  review?: {
    id: string;
    professionalId: string;
    clientId: string;
    bookingId: string;
    rating: number;
    comment: string;
    isPublic: boolean;
  };
}

export interface RespondToReviewData {
  response: string;
}

export class ReviewsModel {
  private static instance: ReviewsModel;

  private constructor() {}

  public static getInstance(): ReviewsModel {
    if (!ReviewsModel.instance) {
      ReviewsModel.instance = new ReviewsModel();
    }
    return ReviewsModel.instance;
  }

  /**
   * Récupère tous les avis pour le professionnel connecté
   */
  public async getMyReviews(): Promise<ReviewsResponse> {
    try {
      const response = await UHttp.get(
        `${apiUrlServer}/api/review/my-reviews`,
        UHttp.authHeaders()
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error ReviewsModel.getMyReviews:', error);
      throw error;
    }
  }

  /**
   * Récupère les statistiques d'avis pour le professionnel connecté
   */
  public async getMyStats(): Promise<ReviewStatsResponse> {
    try {
      const response = await UHttp.get(
        `${apiUrlServer}/api/review/my-stats`,
        UHttp.authHeaders()
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error ReviewsModel.getMyStats:', error);
      throw error;
    }
  }

  /**
   * Répond à un avis client
   * @param reviewId ID de l'avis
   * @param responseData Données de la réponse
   */
  public async respondToReview(reviewId: string, responseData: RespondToReviewData): Promise<ReviewResponse<Review>> {
    try {
      const response = await UHttp.post(
        `${apiUrlServer}/api/review/respond/${reviewId}`,
        responseData,
        UHttp.authHeaders()
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseJson = await response.json();
      return responseJson;
    } catch (error: any) {
      console.error(`Error ReviewsModel.respondToReview ${reviewId}:`, error);
      throw error;
    }
  }
}